"use client";
import * as React from "react";
const SvgRemoveRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 2", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M12 1a1 1 0 0 1-1 1H1a1 1 0 0 1 0-2h10a1 1 0 0 1 1 1" }));
export {
  SvgRemoveRound as default
};
